import { render, staticRenderFns } from "./SelectSummyModal.vue?vue&type=template&id=1276d8a8&scoped=true"
import script from "./SelectSummyModal.vue?vue&type=script&lang=js"
export * from "./SelectSummyModal.vue?vue&type=script&lang=js"
import style0 from "./SelectSummyModal.vue?vue&type=style&index=0&id=1276d8a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1276d8a8",
  null
  
)

export default component.exports